module.exports = __webpack_public_path__ + "media/images/shared/about_live/say/1-c51eca5335ff6d4b539973277b4dce2b.png";